import { useQuery } from '@apollo/client';
import { CITRIN_GET_PRICINGS, GetPricingsRequest, GetPricingsResponse } from '..';

export const useGetPricingsQuery = () => {
    const { data, previousData, ...rest } = useQuery<GetPricingsResponse, GetPricingsRequest>(CITRIN_GET_PRICINGS, {
        fetchPolicy: 'network-only',
        // onCompleted: (data) => console.log('[MGT] Pricing', data),
    });

    return { ...rest, previousData: previousData?.CITRIN_MGT_getPricings, data: data?.CITRIN_MGT_getPricings ?? [] };
};
